module.exports = __webpack_public_path__ + "media/images/emblems/Salmsach-Blazono-e1812919874d8a62578567ae4c842f4d.png";